module.exports = __webpack_public_path__ + "img/sipuni.e36e468a.png";